<template>
  <!-- banner-page -->
  <FranchiseBannerPageComponent />
  <!-- /banner-page -->

  <!-- wg-franchises -->
  <NewFranchiseComponent />
  <!-- /wg-franchises -->

  <!-- wg-location -->
  <LocationComponent />
  <!-- /wg-location -->
</template>

<script>
import FranchiseBannerPageComponent from "./FranchiseBannerPageComponent.vue";
import LocationComponent from "./LocationComponent.vue";
import NewFranchiseComponent from "./NewFranchiseComponent.vue";

export default {
  name: "FranchiseComponent",
  components: {
    FranchiseBannerPageComponent,
    NewFranchiseComponent,
    LocationComponent
  },
};
</script>

<style>
/* Add your CSS styles here */
</style>
